import { useEffect, useRef, useCallback } from 'react';

// Cancel reads on replacement/unmount and reject late responses even if cancellation races.
export default function useLatestRead() {
  const current = useRef(null);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; current.current?.abort(); };
  }, []);
  return useCallback(() => {
    current.current?.abort();
    const controller = new AbortController();
    current.current = controller;
    if (!mounted.current) controller.abort();
    return {
      signal: controller.signal,
      isCurrent: () => mounted.current && current.current === controller && !controller.signal.aborted,
    };
  }, []);
}
